import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import axios from 'axios';
import VueAxios from 'vue-axios';
import jQuery from 'jquery';
import i18n from './i18n';
import api from './service';
import VueScrollTo from 'vue-scrollto';
import VueClipboard from 'vue-clipboard2';
Vue.config.productionTip = false;
Vue.use(VueAxios, axios);
Vue.use(VueScrollTo);
Vue.use(VueClipboard);
window.$ = window.jQuery = jQuery;
Vue.prototype.$api = api;
new Vue({
    // axios,
    router,
    store,
    vuetify,
    i18n,
    render: h => h(App)
}).$mount('#app');
